module.exports = __webpack_public_path__ + "assets/images/bag-off.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/bag-off.png
// module id = 177
// module chunks = 1